import React from "react";
import {useWorkspace} from "../../lib/context";
import SearchableDropdown from "./SearchableDropdown";
import {ChevronDown} from "lucide-react";
import {Dropdown} from "antd";

const WorkspaceDrawer =  () => {
    const workspace = useWorkspace();

    return (
        <div className="flex justify-between bg-[var(--graph8-surface-element)] text-[var(--graph8-text)] gap-2.5 rounded-3xl py-2 px-4 cursor-pointer hover:opacity-80 transition-all border border-transparent">
            <Dropdown
                dropdownRender={() => (
                    <SearchableDropdown fetchUrl={"/api/workspace"} currentWorkspace={workspace} />
                )}
                placement="bottomLeft"
                arrow
                trigger={["click"]}
            >
                <div className="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 lucide lucide-layers-icon lucide-layers">
                        <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z"/>
                        <path d="M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12"/>
                        <path d="M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17"/>
                    </svg>
                    <span className="text-xs text-[var(--graph8-text)]">{workspace.name}</span>
                    <ChevronDown className="ml-2 text-[var(--graph8-text)]" size={16}/>
                </div>

            </Dropdown>
        </div>
    );
}

export default WorkspaceDrawer;
